//www.npmjs.com/package/react-sketch-canvas#demo-httpsvinothinforeact-sketch-canvas
import Avatar from "@material-ui/core/Avatar";
import Box from "@material-ui/core/Box";
import IconButton from "@material-ui/core/IconButton";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import { makeStyles } from "@material-ui/core/styles";
import BorderColorIcon from "@material-ui/icons/BorderColor";
import DeleteIcon from "@material-ui/icons/Delete";
import GetAppIcon from "@material-ui/icons/GetApp";
import InsertDriveFileIcon from "@material-ui/icons/InsertDriveFile";
import RemoveCircleOutlineIcon from "@material-ui/icons/RemoveCircleOutline";
import Alert from "@material-ui/lab/Alert";
import saveAs from "file-saver";
import HtmlDocx from "html-docx-js/dist/html-docx";
import _ from 'lodash';
import React, { useRef, useState } from "react";
import { Form, Navbar } from "react-bootstrap";
import { connect, useSelector } from "react-redux";
import { useFetch } from "../actions/fetchData";
import {
	fileSelectionActions,
	fileUnSelectionActions,
	fileUploadActions
} from "../actions/fileUploadActions";
import { getPrincipalHomeScreen } from "../actions/getScreen";
import { loadRoutes, saveRoutes } from "../actions/loadRoutes";
import { saveDocBody } from "../actions/saveDocBody";
import { saveInputsAction } from "../actions/saveInputsAction";
import socket from "../actions/socketIO";
import { IP } from "../config/IP";
import store from "../store/createStore";
import Button1 from "./containers/Button1";
import Choosefile from "./containers/Choosefile";
import DropdownMenu from "./containers/Dropdownmenu";
import FullScreenDialog from "./containers/FullScreenDialog";
import Input from "./containers/Input";
import Steplist from "./containers/stepslist";
import DocDetails from "./DocDetails";
import "./Home.css";
const useStyles = makeStyles((theme) => ({
	button: {
		margin: theme.spacing(1),
	},
	root: {
		flexGrow: 1,
		maxWidth: 752,
	},
	demo: {
		backgroundColor: theme.palette.background.paper,
	},
	title: {
		margin: theme.spacing(4, 0, 2),
	},
}));

const Home = ({
	getPrincipalHomeScreen,
	loadRoutes,
	saveRoutes,
	saveInputsAction,
	fileUploadActions,
	fileUnSelectionActions,
	docType,
	saveDocBody,
	fileSelectionActions,
	DocId,
	office_id,
	office_name,
	isActing,
}) => {
	const [, forceUpdate] = useState();
	const state = useSelector((state) => state);
	const Ref = useRef(null);
	const classes = useStyles();
	const [details, setDetails] = useState(<>Loading</>);

	var reportindata = [];
	let reportingHierarchy = [];

	console.log("HomeEditingDoc parameter office_id=", office_id);

	if (isActing) {
		reportingHierarchy = state.userStatus.actingOfficeHierarchy[0].find(
			(x) => x.office_id === office_id
		).reportingHierarchy;
	} else {
		reportingHierarchy = state.auth.user.office[0].reportingHierarchy;
	}

	//const max = reportingHierarchy.length;
	//var i = max;
	//console.log("reportingHierarchy[0].id=", reportingHierarchy[0].id);
	let docRules = [];

	if (getPrincipalHomeScreen(state, "SCREEN1")) {
		principalScreens.screen2 = "hide";
		principalScreens.screen3 = "hide";
		principalScreens.screen1 = "";
	}
	if (getPrincipalHomeScreen(state, "SCREEN2")) {
		principalScreens.screen2 = "";
		principalScreens.screen3 = "hide";
		principalScreens.screen1 = "hide";
	}
	if (getPrincipalHomeScreen(state, "SCREEN3")) {
		principalScreens.screen2 = "hide";
		principalScreens.screen1 = "hide";
		principalScreens.screen3 = "";
	}
	console.log("reportindata =", reportindata);
	console.log("principalScreens after usage=", principalScreens);
	let rules = state.loadRoutes;

	const [tab, setTab] = useState("nav-doc-title-tab");
	const [username, setusername] = useState("");
	const [password, setpassword] = useState("");
	const [toggle, setToggle] = useState(false);
	const [show_draft, setShow_draft] = useState(true);
	const [inputValue, setInputValue] = useState("");
	const [buttonclick, setButtonclick] = useState(false);
	const [respondisteps, setRespondisteps] = useState(reportindata);

	const [screens, setScreens] = useState({
		principalScreens: principalScreens,
	});

	const [routesrules, setRoutesrules] = useState(rules);
	const [requiredDocs, setRequiredDocs] = useState();
	const [filterDoc,setFilterDoc]=React.useState([]);
	const [open, setOpen] = useState(false);
	const [FullScreenDialogInfo, setFullScreenDialogInfo] = useState();

	console.log("respondisteps=", respondisteps);
	const [button, setButton] = useState({});
	const [title, setTitle] = useState("");
	const [docBody, setDocBody] = useState();
	const [docTitle, setDocTitle] = useState("");
	const [docTypeId, setDocTypeId] = useState();

	const [firstLoad, setFirstLoad] = React.useState(true);
	const [pageNumber, setPageNumber] = React.useState(1);
	const [numberRowPerPage, setNumberRowPerPage] = React.useState(5);
	const [totalRow, setTotalRow] = React.useState(20);
	let { data, files, loading } = useFetch({
		id: DocId,
		page: pageNumber,
		limit: numberRowPerPage,
	});
	let newdocType = 0;

	console.log("Screens=", screens);

	const inputHandleChange = (e) => {
		console.log("inputHandleChange=", e.target.value);
		document.getElementById("doc_title").innerHTML = e.target.value;
		setInputValue(e.target.value);
	};
	const handleButtonOnclik = (e) => {
		if (getPrincipalHomeScreen(state, "SCREEN1")) {
			principalScreens.screen2 = "hide";
			principalScreens.screen3 = "hide";
			principalScreens.screen1 = "";
		}
		if (getPrincipalHomeScreen(state, "SCREEN2")) {
			principalScreens.screen2 = "";
			principalScreens.screen3 = "hide";
			principalScreens.screen1 = "hide";
		}
		if (getPrincipalHomeScreen(state, "SCREEN3")) {
			principalScreens.screen2 = "hide";
			principalScreens.screen3 = "";
			principalScreens.screen1 = "hide";
		}
		console.log("principalScreens after usage=", principalScreens);
		//setButtonclick("true");
		setButton(e.target);
		setScreens({ principalScreens: principalScreens });

		//if (tab === "nav-doc-title-tab" ) {
		if (handleTabs(state) === "nav-doc-title-tab") {
			console.log("HomeEditingDoc handleTabs docType=", data);
			setRoutesrules(state.loadRoutes);
			setRequiredDocs(
				state.loadRoutes.routes_rules.filter(
					(x) => x.Doc_type_id === parseInt(data.data[0].DocType)
				).requiredDocs
			);
			let elements = document.getElementsByClassName("validation");
			while (elements.length > 0) {
				elements[0].remove();
			}
			if (inputValue !== "") {
				var input = {
					url: IP.nodeServer + "api/saveDoc",
					data: [
						{ name: "type", value: parseInt(data.data[0].DocType) },
						{ name: "name", value: inputValue },
						{
							name: "office_id",
							value: parseInt(office_id),
						},
						{
							name: "companyId",
							value: state.companyData.selectedCompanyId,
						},
						{
							name: "DocId",
							value: DocId,
						},
						{
							name: "status",
							value: 1,
						},
					],
				};
				saveInputsAction(input);
			} else {
				var newItem = document.createElement("DIV"); // Create a <Div> node
				newItem.setAttribute("class", "validation");
				var textnode = document.createTextNode("Element is empty"); // Create a text node

				newItem.appendChild(textnode);

				document.getElementById("inputDocumentTitle").after(newItem);
				document.getElementById("inputDocumentTitle").style.borderColor = "red";
			}
		}

		//if (tab === "nav-doc-draft-tab") {
		if (handleTabs(state) === "nav-doc-draft-tab") {
			let elements = document.getElementsByClassName("validation");
			while (elements.length > 0) {
				elements[0].remove();
			}
			console.log(
				"document.getElementById('docRules')=",
				document.getElementById("docRules")
			);
			var ul = document.getElementById("docRules");

			var item = ul.getElementsByTagName("li");
			if (item) console.log("docRules item=", item[0]);

			var i = 0;
			var filestatus = [];
			for (i = 0; i < item.length; i++) {
				console.log(
					"item[i].getElementsByClassName('MuiListItem-root')[0].id=",
					item[i].getElementsByClassName("MuiListItem-root")[0].id
				);
				console.log(
					"item[i].getElementsByClassName('MuiListItem-root')[0].attributes.rel.value=",
					item[i].getElementsByClassName("MuiListItem-root")[0].attributes.rel
						.value
				);
				console.log("state.fileupload.files=", state.fileupload.files);

				if (
					state.fileupload.files.find(
						(x) =>
							x.id ===
							parseInt(item[i].getElementsByClassName("MuiListItem-root")[0].id)
					)
				) {
					filestatus.push({
						fileId: item[i].getElementsByClassName("MuiListItem-root")[0].id,
						found: true,
					});
				} else {
					filestatus.push({
						fileId: item[i].getElementsByClassName("MuiListItem-root")[0].id,
						found: false,
					});
					var newItem = document.createElement("DIV"); // Create a <Div> node
					newItem.setAttribute("class", "validation");
					var textnode = document.createTextNode("Element is empty"); // Create a text node

					newItem.appendChild(textnode);

					item[i].getElementsByClassName("MuiListItem-root")[0].after(newItem);
					item[i].getElementsByClassName(
						"MuiListItem-root"
					)[0].style.borderColor = "red";
					//textnode.style.borderColor = "thick solid #0000FF";
				}
			}

			console.log("filestatus=", filestatus);

			/*			item.map(x=>
				{

					console.log("List Id=",x.id);
				})

			
			*/

			if (!filestatus.find((x) => x.found === false)) {
				let inputs = [];
				state.fileupload.files.map((x) => {
					inputs = {
						url: IP.nodeServer + "api/upload",
						data: [
							{ name: "file", value: x.file },
							{ name: "docId", value: state.inputsave.id },
							{ name: "fileType", value: x.id },
							{ name: "office_id", value: office_id },
							{ name: "status", value: 2 },
						],
					};
					console.log(
						"nav-doc-draft-tab  this.props Home before upload =",
						state
					);
					fileUploadActions(inputs);
					console.log(
						"nav-doc-draft-tab  this.props Home after upload =",
						state
					);
					console.log("upload x=", x);
				});
				handleChange(DocId);
			}
		}
		//if (tab === "nav-doc-route-tab") {
		if (handleTabs(state) === "nav-doc-route-tab") {
			let inputs = {
				url: IP.nodeServer + "api/updateDocRoutes",
				data: {
					StepProgress: reportindata,
					docId: state.inputsave.id,
					office_id: office_id,
					status: 3,
				},
			};
			saveRoutes(inputs);

			inputs = {
				url: IP.nodeServer + "api/updateDocRoutes",
				id: state.inputsave.id,
			};

			//getDocsById(inputs);

			console.log("nav-doc-route-tab  this.props Home=", state);
			console.log("value DocId.DocId=" + DocId.length);
			console.log(
				"store.getState().loadRoutes before retuning details=",
				store.getState().loadRoutes
			);
		}
	};

	const toggleState = () => {
		setToggle(!toggle);
	};
	const handleScreen = (e) => {
		console.log("handleScreen gived", e.target.id);
		//	this.getPrincipalHomeScreen(this.props.state, e.target.id);
	};
	handleTabs(state);
	const handleClick = (e) => {
		e.preventDefault();
		var element = document.getElementById(e.target.id);

		if (e.target.id === "nav-doc-route-tab") {
			/*let inputs = {
				url: IP.nodeServer+"api/routes",
				method: "GET",
				data: [{ name: "Doc_type_id", value: 1 }]
			};
			this.props.loadRoutes(inputs);
			console.log(
				"state after this.props.loadRoutes(inputs)=",
				this.props.state
			);
			*/
			if (document.getElementById(e.target.id)) {
				element = document.getElementById(e.target.id);
				element.classList.add("show");
				element.classList.add("active");
			}
			if (document.getElementById("nav-doc-route")) {
				element = document.getElementById("nav-doc-route");
				element.classList.add("active");
				element.classList.add("show");
			}
			if (document.getElementById("nav-doc-title")) {
				element = document.getElementById("nav-doc-title");
				element.classList.remove("show");
				element.classList.remove("active");
			}

			if (document.getElementById("nav-doc-title-tab")) {
				element = document.getElementById("nav-doc-title-tab");
				element.classList.remove("active");
			}

			if (document.getElementById("nav-doc-draft-tab")) {
				element = document.getElementById("nav-doc-draft-tab");
				element.classList.remove("active");
			}

			if (document.getElementById("nav-doc-draft")) {
				element = document.getElementById("nav-doc-draft");
				element.classList.remove("show");
				element.classList.remove("active");
			}
			setShow_draft(false);
			setTab(e.target.id);
		} else if (e.target.id === "nav-doc-draft-tab") {
			setTab(e.target.id);
			if (document.getElementById(e.target.id)) {
				element = document.getElementById(e.target.id);
				element.classList.add("active");
			}
			if (document.getElementById("nav-doc-title")) {
				element = document.getElementById("nav-doc-title");
				element.classList.remove("show");
				element.classList.remove("active");
			}
			if (document.getElementById("nav-doc-title-tab")) {
				element = document.getElementById("nav-doc-title-tab");
				element.classList.remove("show");
				element.classList.remove("active");
			}
			if (document.getElementById("nav-doc-route-tab")) {
				element = document.getElementById("nav-doc-route-tab");
				element.classList.remove("active");
			}
			if (document.getElementById("nav-doc-draft")) {
				element = document.getElementById("nav-doc-draft");
				element.classList.add("show");
				element.classList.add("active");
			}
			if (document.getElementById("nav-doc-route")) {
				element = document.getElementById("nav-doc-route");
				element.classList.remove("show");
				element.classList.remove("active");
			}

			setShow_draft(true);
			setTab(e.target.id);
		} else if (e.target.id === "nav-doc-title-tab") {
			if (document.getElementById(e.target.id)) {
				element = document.getElementById(e.target.id);
				element.classList.add("active");
			}

			if (document.getElementById("nav-doc-title-tab")) {
				element = document.getElementById("nav-doc-title-tab");
				element.classList.add("active");
			}

			if (document.getElementById("nav-doc-route-tab")) {
				element = document.getElementById("nav-doc-route-tab");
				element.classList.remove("active");
			}
			if (document.getElementById("nav-doc-draft-tab")) {
				element = document.getElementById("nav-doc-draft-tab");
				element.classList.remove("active");
			}
			if (document.getElementById("nav-doc-title")) {
				element = document.getElementById("nav-doc-title");
				element.classList.add("show");
				element.classList.add("active");
			}
			if (document.getElementById("nav-doc-draft")) {
				element = document.getElementById("nav-doc-draft");
				element.classList.remove("show");
				element.classList.remove("active");
			}

			if (document.getElementById("nav-doc-draft")) {
				element = document.getElementById("nav-doc-draft");
				element.classList.remove("show");
				element.classList.remove("active");
			}
			if (document.getElementById("nav-doc-route")) {
				element = document.getElementById("nav-doc-route");
				element.classList.remove("show");
				element.classList.remove("active");
			}

			setShow_draft(true);
			setTab(e.target.id);
		} else {
		}
	};

	console.log("this.props Home=", state);

	const menuItems = [
		{
			label: "Clone",
			icon: "fa fa-clone",
			onClick: () => alert("Clone"),
		},
		{
			label: "Share",
			icon: "fa fa-bullhorn",
			onClick: () => alert("Share"),
		},
		{
			label: "Delete",
			icon: "fa fa-trash-o",
			onClick: () => alert("Delete"),
		},
	];

	console.log("Home 2 state.inputsave.id=", state.inputsave.id);

	/*
	React.useEffect(() => {
		setDetails(
			store.getState().inputsave.id !== null ? (
				<>
					<DocDetails DocId={store.getState().inputsave.id} />
				</>
			) : (
				<></>
			)
		);
	}, []);
	*/

	const handleUploadFile = (fileId) => {
		console.log("handleUploadFile=", fileId);
	};
	const handleChange = (DocId) => {
		if (DocId) {
			//if (newValue === "two") {
			let inputs = {
				url: IP.nodeServer + "api/getDocs",
				method: "POST",
				id: DocId,
			};
			console.log("handle change newDocId=", DocId);

			//getDocsById(inputs);

			//}
		}
	};
	const handleDeleteSelectedFile = (e, value) => {
		console.log("handleDeleteSelectedFile clicked=", e.target);
		let input = value;
		fileUnSelectionActions(input);
		console.log(
			"handleDeleteSelectedFile  state.fileupload.files=",
			state.fileupload.files
		);
		console.log("handleDeleteSelectedFile value=", value);
		console.log(
			"handleDeleteSelectedFile state.fileupload.files=",
			state.fileupload.files
		);
	};
	const handleRemoveElementFileFromList = (e, value) => {
		console.log(
			"handleRemoveElementFileFromList routesrules clicked=",
			routesrules.routes_rules
		);
		console.log(
			"handleRemoveElementFileFromList docType=",
			data.data[0].DocType
		);

		console.log(" handleRemoveElementFileFromList  value=", value);
		console.log(
			"routesrules.routes_rules.filter((x) => parseInt(x.Doc_type_id) === parseInt(docType))=",
			routesrules.routes_rules.filter(
				(x) => parseInt(x.Doc_type_id) === parseInt(data.data[0].DocType)
			)
		);
		/*console.log(
			"routesrules.filter(x => x.id !== value.id)=",
			routesrules.routes_rules
				.filter(
					(x) => parseInt(x.Doc_type_id) === parseInt(data.data[0].DocType)
				)[0]
				.requiredDocs.filter((x) => x.id !== value)
		);
		*/
			let filterDocTmp=filterDoc;
				filterDocTmp.push(value);
				//console.log("filterDocTmp=",filterDocTmp)
		setRequiredDocs(
			routesrules.routes_rules
				.filter(
					(x) => parseInt(x.Doc_type_id) === parseInt(data.data[0].DocType)
				)[0]
				.requiredDocs.filter((x) => !filterDocTmp.includes(x.id ))
		);

		//setRoutesrules(routesrules.routes_rules.filter((x) => x.id !== value));
	};
	const handleClose = () => {
		console.log("handleClose clicked!");
		setOpen(false);
		setFullScreenDialogInfo(
			<FullScreenDialog
				ref={Ref}
				openDialog={false}
				handleClose={handleClose}
				handleSaveText={handleSaveText}
				onHandleDocBodyChange={onHandleDocBodyChange}
				onHandleDocTitleChange={onHandleDocTitleChange}
				docBody={docBody}
				docTitle={docTitle}
				firstText="Drafting"
				secondText="Memo"
				showInputText={true}
			/>
		);
	};

	//Start editing Text controls
	const onHandleDocBodyChange = async (e) => {
		if (e.length > 0) {
			setDocBody(e);
			console.log("docBody from home=", docBody);
			console.log("docTypeId=", docTypeId);
		}
	};
	const onHandleDocTitleChange = (e) => {
		setDocTitle(e.target.value);
		console.log("docTitle=", docTitle);
	};

	//End editing Text Controls
	const handleListItemClick = (itemId) => {
		console.log("handleListItemClick clicked e.target.id", itemId);
		console.log("state.fileupload.files=", state.fileupload.files);

		let files = state.fileupload.files;
		console.log("handleFileClick value=", itemId);
		console.log(
			"handleFileClick files=",

			files.find((x) => x.id === itemId).file
		);
		let file = files.find((x) => x.id === itemId).file;

		saveAs(file, file.name);
	};

	const handleSaveText = () => {
		let elements = document.getElementsByClassName("validation");
		while (elements.length > 0) {
			elements[0].remove();
		}

		var newItem = document.createElement("DIV"); // Create a <Div> node
		newItem.setAttribute("class", "validation");
		var textnode = document.createTextNode("Element is empty"); // Create a text node

		newItem.appendChild(textnode);

		const newstate = store.getState();
		console.log("newstate=", newstate);
		if (newstate.draftDocs.body) {
			if (!newstate.draftDocs.body.docBody) {
				document.getElementById("textEditorBody").after(newItem);
				document.getElementById("textEditorBody").style.borderColor = "red";
				return console.log(
					"message#1 newstate.draftDocs.body.docBody is empty"
				);
			}
		}
		if (!newstate.draftDocs.body.docTitle) {
			document.getElementById("textEditorTitle").after(newItem);
			document.getElementById("textEditorTitle").style.borderColor = "red";
			return console.log("message#2 newstate.draftDocs.body.docTitle is empty");
		}
		if (
			newstate.draftDocs.body.docBody.replace(/(<([^>]+)>)/gi, "").length === 0
		) {
			document.getElementById("textEditorBody").after(newItem);
			document.getElementById("textEditorBody").style.borderColor = "red";
			return console.log("message#3 newstate.draftDocs.body.docBody is empty");
		}
		if (newstate.draftDocs.body.docTitle.length === 0) {
			document.getElementById("textEditorTitle").after(newItem);
			document.getElementById("textEditorTitle").style.borderColor = "red";
			return console.log("message#4 newstate.draftDocs.body.docTitle is empty");
		}
		console.log(
			"handleSaveText with docBody=",
			newstate.draftDocs.body.docBody
		);
		console.log(
			"handleSaveText  with docTypeId=",
			newstate.draftDocs.body.docTypeId
		);
		console.log("handleSaveText  with DocId=", state.inputsave.id);
		console.log("handleSaveText clicked!");

		var html = "";
		var title = newstate.draftDocs.body.docTitle;
		let filename = title + ".docx";
		html =
			'<!DOCTYPE html><html><head lang="en"><meta charset="UTF-8"><title></title></head><body>' +
			newstate.draftDocs.body.docBody +
			"</body></html>";
		console.log("state.draftDocs=", newstate.draftDocs.body.draftDocs);

		var docx = HtmlDocx.asBlob(html);
		//saveAs(docx, "test.docx");
		//docx.lastModifiedDate = new Date();
		//docx.name = filename;
		var file = new File([docx], filename, {
			lastModified: Math.round(new Date().getTime() / 1000),
		});

		fileSelectionActions({
			file: file,
			id: newstate.draftDocs.body.docTypeId,
		});
		console.log("docx=", docx);
		handleClose();
	};

	const handleDraftElementFileFromList = (e, input) => {
		setDocTypeId(input);
		console.log("handleDraftElementFileFromList clicked=", input);
		setOpen(true);
		console.log("handleDraftElementFileFromList openFullDialog=", open);
		setFullScreenDialogInfo(
			<Box borderLeft={10} borderLeft={0}>
				<FullScreenDialog
					openDialog={true}
					handleClose={handleClose}
					handleSaveText={handleSaveText}
					onHandleDocBodyChange={onHandleDocBodyChange}
					onHandleDocTitleChange={onHandleDocTitleChange}
					docBody={docBody}
					docTitle={docTitle}
					firstText="Drafting"
					secondText="Memo"
					showInputText={true}
				/>{" "}
			</Box>
		);
	};

	let docRulesitems = [];

	if (state.loadRoutes.routes_rules && !loading) {
		console.log("routesrules HomeEditingDoc=", routesrules.routes_rules);

		if (routesrules.routes_rules) {
			docRules = routesrules.routes_rules
				.filter((x) => x.Doc_type_id === parseInt(data.data[0].DocType))
				.map((x) => x);
			console.log("if (routesrules.routes_rules)  =", routesrules.routes_rules);
		} else {
			docRules = state.loadRoutes.routes_rules
				.filter((x) => x.Doc_type_id === parseInt(data.data[0].DocType))
				.map((x) => x);
			console.log(
				"else (routesrules.routes_rules)  state.loadRoutes.routes_rules=",
				state.loadRoutes.routes_rules
			);
		}

		console.log("docRules after condition routesrules.routes_rules=", docRules);
		if (state.fileupload.files[0]) {
			console.log(
				"state.fileupload.files",
				state.fileupload.files[0].file.name
			);
		}
		let requiredocitem = [];
		if (requiredDocs) {
			requiredocitem = requiredDocs;
		} else {
			console.log("docRules===", docRules);
			requiredocitem = docRules[0].requiredDocs;
		}
		docRulesitems = requiredocitem.map((x) => (
			<ListItem key={x.id} id={x.id} rel={x.mandatory}>
				<ListItemAvatar>
					<Avatar>
						<InsertDriveFileIcon />
					</Avatar>
				</ListItemAvatar>

				{state.fileupload.files.find((y) => y.id === x.id) ? (
					<a>{state.fileupload.files.find((y) => y.id === x.id).file.name}</a>
				) : (
					<Choosefile noFile={x.id} fileName={x.id} />
				)}
				<ListItemText edge="end" primary={x.name} secondary={x.mandatory} />

				<ListItemSecondaryAction>
					{x.allowDrafting &&
					!state.fileupload.files.find((y) => y.id === x.id) ? (
						<IconButton
							edge="end"
							aria-label="Draft"
							onClick={(e) => handleDraftElementFileFromList(e, x.id)}
						>
							<BorderColorIcon />
						</IconButton>
					) : (
						""
					)}
					{state.fileupload.files.find((y) => y.id === x.id) ? (
						<>
							<IconButton
								edge="end"
								aria-label="Open"
								onClick={() => handleListItemClick(x.id)}
							>
								<GetAppIcon />
							</IconButton>
							<IconButton
								edge="end"
								aria-label="delete"
								onClick={(e) => handleDeleteSelectedFile(e, x.id)}
							>
								<DeleteIcon />
							</IconButton>
						</>
					) : x.mandatory === "N" ? (
						<IconButton
							edge="end"
							aria-label="Remove"
							onClick={(e) => handleRemoveElementFileFromList(e, x.id)}
						>
							<RemoveCircleOutlineIcon />
						</IconButton>
					) : (
						""
					)}
				</ListItemSecondaryAction>
			</ListItem>
		));

		if (state.loadRoutes.routes_rules && !loading) {
			// start of reporting
			//while (i > 0) {
			//	i--;
			console.log("routesrules=", state.loadRoutes.routes_rules);
			let docRules = [];
			if (state.loadRoutes.routes_rules) {
				docRules = state.loadRoutes.routes_rules.filter(
					(x) => x.Doc_type_id === parseInt(docType)
				);

				console.log(
					"if (routesrules.routes_rules)  coroutesrules=",
					state.loadRoutes.routes_rules
				);
				console.log("if (routesrules.routes_rules)  docType=", docType);
			}

			// Now let remove offices that are not to include

			if (docRules[0].remove_office_id) {
				docRules[0].remove_office_id.map((x) => {
					console.log(
						"docRules[0].remove_office_id  x.office_id=",
						x.office_id
					);
					reportingHierarchy = reportingHierarchy.filter(
						(y) => y.office_id !== x.office_id
					);
				});
			}
			// End of removing offices that are not to include
			// Start of adding  offices that are not to include
			if (docRules[0].add_office_id) {
				//reportingHierarchy.reverse();
				console.log(
					"add_office_id state.auth.user.allOffices=",
					state.auth.user.allOffices
				);
				let firstsort = false;
				let secondsort = false;
				if (reportingHierarchy.length === 1 || reportingHierarchy.length === 0)
					firstsort = true;

				// First sort office by level of reporting to add by the order store is the store
				reportingHierarchy = reportingHierarchy.sort((a, b) => {
					firstsort = true;
					return a.level > b.level ? -1 : 1;
				});
				console.log("reportingHierarchy after sorting=", reportingHierarchy);
				

				if (firstsort) {
					let max = reportingHierarchy.length;
					let count=0;
					docRules[0].add_office_id
						.sort((a, b) => (a.order > b.order ? -1 : 1))
						.map((x, index) => {
							console.log(
								"docRules[0].add_office_id  x.office_id=",
								x.office_id
							);
							console.log(
								"state.auth.user.allOffices.find",
								state.auth.user.allOffices.find(
									(y) => y.office_id === x.office_id
								)
							);
							let office = state.auth.user.allOffices.find(
								(y) => y.office_id === x.office_id
							);
							if(!reportingHierarchy.map(x=>x.office_id).includes(office.office_id))
						{
							reportingHierarchy.push({
								office_id: office.office_id,
								office_name: office.office_name,
								level: max + count,
							});
						}
						count++;
							secondsort = true;
						});
					if (secondsort) {
						console.log(
							"before secondsort reportingHierarchy=",
							reportingHierarchy
						);
						reportingHierarchy = reportingHierarchy.sort((a, b) =>
							a.level > b.level ? -1 : 1
						);
						console.log(
							"after secondsort reportingHierarchy=",
							reportingHierarchy
						);
					}
				}
			}
			// End of adding  offices that are  to include
			console.log("reportingHierarchy after removing =", reportingHierarchy);

			//if (reportingHierarchy[0].office_id !== 1)

			let max = 0;

			max = reportingHierarchy.length;
			var i = max;

			for (i = 0; i < reportingHierarchy.length; i++) {
				reportindata.push({
					step: max - i + 1,
					id: reportingHierarchy[i].office_id,
					name: reportingHierarchy[i].office_name,
					note: "",
					status: "",
					statusDate: "",
				});
			}
			console.log("reportingHierarchy reportingHierarchy=", reportingHierarchy);
			console.log("reportingHierarchy reportindata=", reportindata);
			if (true) {
				for (i = 0; i < state.auth.user.office.length; i++) {
					reportindata.push({
						step: 1,
						id: office_id,
						name: office_name,
						note: "",
						status: 0,
						statusDate: new Date(),
					});
				}
				max = reportindata.length;
				reportindata = reportindata.map((x, index) => ({
					...x,
					step: max - index,
				}));
				console.log("after all operation reportindata=", reportindata);
			}

			// end of reporting


			if(reportindata.filter(x=>parseInt(x.id)===parseInt(office_id)).length>1)
	{

	let maxOwnHierachy=_.maxBy(reportindata.filter(x=>x.id===office_id), 'step')

console.log("maxOwnHierachy=",maxOwnHierachy)
let max=reportindata.filter(x=> x.step>=maxOwnHierachy.step).length;
reportindata = reportindata.filter(x=> x.step>=maxOwnHierachy.step).map((x, index) => ({
			...x,
			step: max - index,
		}));

	}
		}
	}

	React.useEffect(() => {
		console.log("mounting  Home  with open=", FullScreenDialogInfo);
	}, [FullScreenDialogInfo, setFullScreenDialogInfo]);
	React.useEffect(() => {
		if (docBody) {
			console.log("mounting  Home  with docBody=", docBody);
			console.log("mounting  Home  with docTypeId=", docTypeId);
			console.log("mounting  Home  with DocId=", state.inputsave.id);
			saveDocBody({
				docId: state.inputsave.id,
				docTypeId: docTypeId,
				docBody: docBody,
				docTitle: docTitle,
			});
		}
	}, [docBody, setDocBody, docTypeId, docTitle]);

	console.log("state.loadRoutes=", state.loadRoutes.docType);
	console.log("openFullDialog before return=", open);

	console.log("Ref.current  Home1=", Ref.current);
	React.useEffect(() => {
		if (store.getState().loadRoutes.isSaved) {
			if (DocId.length > 0) {
				setDetails(<DocDetails DocId={state.inputsave.id} />);
			}
		}
	}, [store.getState().loadRoutes.isSaved]);
	React.useEffect(()=>
	{
		if(state.docSubmit.isSubmitted)
		{
        socket.emit("newDocSubmitted",{DocId:DocId});
			console.log("state.docSubmit.isSubmitted=",state.docSubmit.isSubmitted)
		}
		

	},[state.docSubmit.isSubmitted])

	React.useEffect(() => {
		console.log("real   DocDetails  with DocId=", DocId);
		if (!loading) {
			// get the name of the document
			let varal = { e: { target: { value: data.data[0].DocName } } };
			console.log("varal=", varal.e);
			if (varal.e.target.value) {
				inputHandleChange(varal.e);
			}
			newdocType = data.data[0].DocType;
			console.log("HomeEditingDoc data.data[0]=", data.data[0]);
			console.log("HomeEditingDoc files before HomeEditingDoc =", files);
			console.log(
				"HomeEditingDoc state.loadRoutes.docType=",
				state.loadRoutes.docType
			);
			console.log("HomeEditingDoc newdocType=", newdocType);
			if (files.length > 0)
				files[0].map((x) => {
					console.log("files before HomeEditingDoc x=", x);
					var buffer = Buffer.from(x.file.data);
					var blob = new Blob([buffer], {
						type: x.file.contentType,
					});
					var filedata = new File([blob], x.file.name, {
						lastModified: Math.round(new Date().getTime() / 1000),
					});
					console.log("files before HomeEditing Docfiledata=", filedata);
					let file = { file: filedata, id: x.fileType };
					console.log("files before HomeEditingDoc file=", file);
					fileSelectionActions(file);
				});
			//fileSelectionActions({file: file,id: newstate.draftDocs.body.docTypeId,});
		}
		return () => {
			console.log("real Unmounting  DocDetails");
		};
	}, [DocId, loading]);

	return loading && newdocType === 0 ? (
		<div>Loading in</div>
	) : (
		<>
			<Box>
				<div id="processing_dv">
					<section className="statis text-center">
						<div className="container-fluid">
							<ul className="progressbar">
								<li
									id="screen1"
									className={
										"active " + (state.loadRoutes.isSaved ? "is-done" : "")
									}
									onClick={handleScreen}
								>
									Edit Document
								</li>
								<li
									id="screen2"
									className={
										state.loadRoutes.isSaved
											? "active " +
											  (state.docSubmit.isSubmitted ? "is-done" : "")
											: ""
									}
									onClick={handleScreen}
								>
									Review document
								</li>
								<li
									id="screen3"
									onClick={handleScreen}
									className={
										state.docSubmit.isSubmitted ? "active is-done" : ""
									}
								>
									Submit
								</li>
							</ul>
						</div>
					</section>
					<Navbar bg="primary" variant="dark">
						<Navbar.Brand>
							Document ({" "}
							{state.loadRoutes.docType && newdocType !== null
								? state.loadRoutes.docType.filter(
										(x) => x.Doc_type_id === parseInt(data.data[0].DocType)
								  )[0].name
								: " loading "}
							)<span id="doc_title"></span>
						</Navbar.Brand>

						<Navbar.Collapse className="justify-content-end">
							<Form inline>
								<DropdownMenu items={menuItems} />
							</Form>
						</Navbar.Collapse>
					</Navbar>
					<div className={screens.principalScreens.screen1}>
						<nav>
							<div className="nav nav-tabs" id="nav-tab" role="tablist">
								<a
									className="nav-item nav-link previous round"
									id="nav-doc-previour-tab"
									data-toggle="tab"
									href="#nav-previous"
									role="tab"
									aria-controls="nav-doc-previous"
									aria-selected="false"
									onClick={handleClick}
								>
									&#8249;
								</a>
								{!state.inputsave.isSaved && (
									<a
										className={
											"nav-item nav-link " +
											(!state.inputsave.isSaved ? "active" : "")
										}
										id="nav-doc-title-tab"
										data-toggle="tab"
										href="#nav-title"
										role="tab"
										aria-controls="nav-doc-title"
										aria-selected="true"
										onClick={handleClick}
									>
										Doc Title
									</a>
								)}
								{state.inputsave.isSaved && (
									<a
										className={
											"nav-item nav-link " +
											(state.inputsave.isSaved && !state.fileupload.isUpLoaded
												? "active"
												: "")
										}
										id="nav-doc-draft-tab"
										data-toggle="tab"
										href="#nav-draft"
										role="tab"
										aria-controls="nav-doc-draft"
										aria-selected="true"
										onClick={handleClick}
									>
										Draft/Upload
									</a>
								)}
								{state.fileupload.isUpLoaded && (
									<a
										className={
											"nav-item nav-link " +
											(state.fileupload.isUpLoaded ? "active" : "")
										}
										id="nav-doc-route-tab"
										data-toggle="tab"
										href="#nav-route"
										role="tab"
										aria-controls="nav-doc-route"
										aria-selected="false"
										onClick={handleClick}
									>
										Routing
									</a>
								)}
								{!buttonclick && (
									<a
										className="nav-item nav-link"
										id="nav-doc-save-tab"
										data-toggle="tab"
										href="#nav-save"
										role="tab"
										aria-controls="nav-doc-save"
										aria-selected="false"
										onClick={handleClick}
									>
										<Button1
											content=""
											variant="transparent"
											icon="fa fa-floppy-o"
											onClick={handleButtonOnclik}
										/>
									</a>
								)}
								<a
									className="nav-item nav-link next round"
									id="nav-doc-next-tab"
									data-toggle="tab"
									href="#nav-next"
									role="tab"
									aria-controls="nav-doc-next"
									aria-selected="false"
									onClick={handleClick}
								>
									&#8250;
								</a>
							</div>
						</nav>

						<div className="tab-content" id="nav-tabContent">
							<div
								className={
									"tab-pane fade " +
									{ ...(!state.inputsave.isSaved ? "show active" : "") }
								}
								id="nav-doc-title"
								role="tabpanel"
								aria-labelledby="nav-doc-title-tab"
							>
								<section className="statis text-center">
									<div className="container-fluid">
										<div className="row">
											<div className="col-md-6">
												
												<Input
													inputType="Text"
													inputName="inputDocumentTitle"
													inputId="inputDocumentTitle"
													inputPlaceHolder="Document Title"
													inputValue={inputValue}
													handleChange={inputHandleChange}
												/>
											</div>
										</div>
									</div>
								</section>
							</div>

							<div
								className={
									"tab-pane fade " +
									{
										...(state.inputsave.isSaved && !state.fileupload.isUpLoaded
											? "show active"
											: ""),
									}
								}
								id="nav-doc-draft"
								role="tabpanel"
								aria-labelledby="nav-doc-draft-tab"
							>
								<section className="statis text-center">
									<div className="container-fluid">
										<div className="row">
											<div className="col-md-6">
												{state.loadRoutes.routes_rules && (
													<Box color="text.primary">
														
														{filterDoc.length>0 && <Button1 content="Restore removed Doc"
											variant="transparent"
											icon="fa fa-remove" onClick={()=>
											{setFilterDoc([]);}}/> }
														<List id="docRules">{docRulesitems}</List>
													</Box>
												)}
											</div>
										</div>
									</div>
								</section>
							</div>
							<div
								className={
									"tab-pane fade " +
									{ ...(state.fileupload.isUpLoaded ? "show active" : "") }
								}
								id="nav-doc-route"
								role="tabpanel"
								aria-labelledby="nav-doc-route-tab"
							>
								<section className="statis text-center">
									<div className="container-fluid">
										<div className="row">
											<div className="col-md-6">
												<Steplist userdata={reportindata} />
											</div>
										</div>
									</div>
								</section>
							</div>
						</div>
					</div>
					<div className={screens.principalScreens.screen2}>
						screen2
						{details}
						<Box component="span" m={1}>
							<Button1 />
						</Box>
					</div>
					<div className={screens.principalScreens.screen3}>
						<Alert variant="filled" severity="success">
							You have successly submitted the Document
						</Alert>
					</div>
					{FullScreenDialogInfo}
				</div>
			</Box>
		</>
	);
};

const handleTabs = (state) => {
	console.log("state from handleTabs=", state);
	let element;
	let tab = "";
	if (state.fileupload.isUpLoaded) {
		if (document.getElementById("nav-doc-route-tab")) {
			element = document.getElementById("nav-doc-route-tab");
			element.classList.add("show");
			element.classList.add("active");
		}
		if (document.getElementById("nav-doc-route")) {
			element = document.getElementById("nav-doc-route");
			element.classList.add("active");
			element.classList.add("show");
		}
		if (document.getElementById("nav-doc-title")) {
			element = document.getElementById("nav-doc-title");
			element.classList.remove("show");
			element.classList.remove("active");
		}

		if (document.getElementById("nav-doc-title-tab")) {
			element = document.getElementById("nav-doc-title-tab");
			element.classList.remove("active");
		}

		if (document.getElementById("nav-doc-draft-tab")) {
			element = document.getElementById("nav-doc-draft-tab");
			element.classList.remove("active");
		}

		if (document.getElementById("nav-doc-draft")) {
			element = document.getElementById("nav-doc-draft");
			element.classList.remove("show");
			element.classList.remove("active");
		}
		tab = "nav-doc-route-tab";
	} else if (state.inputsave.isSaved) {
		if (document.getElementById("nav-doc-draft-tab")) {
			element = document.getElementById("nav-doc-draft-tab");
			element.classList.add("active");
		}
		if (document.getElementById("nav-doc-title")) {
			element = document.getElementById("nav-doc-title");
			element.classList.remove("show");
			element.classList.remove("active");
		}
		if (document.getElementById("nav-doc-title-tab")) {
			element = document.getElementById("nav-doc-title-tab");
			element.classList.remove("show");
			element.classList.remove("active");
		}
		if (document.getElementById("nav-doc-route-tab")) {
			element = document.getElementById("nav-doc-route-tab");
			element.classList.remove("active");
		}
		if (document.getElementById("nav-doc-draft")) {
			element = document.getElementById("nav-doc-draft");
			element.classList.add("show");
			element.classList.add("active");
		}
		if (document.getElementById("nav-doc-route")) {
			element = document.getElementById("nav-doc-route");
			element.classList.remove("show");
			element.classList.remove("active");
		}
		tab = "nav-doc-draft-tab";
	} else {
		if (document.getElementById("nav-doc-title-tab")) {
			element = document.getElementById("nav-doc-title-tab");
			element.classList.add("active");
		}

		if (document.getElementById("nav-doc-route-tab")) {
			element = document.getElementById("nav-doc-route-tab");
			element.classList.remove("active");
		}
		if (document.getElementById("nav-doc-draft-tab")) {
			element = document.getElementById("nav-doc-draft-tab");
			element.classList.remove("active");
		}
		if (document.getElementById("nav-doc-title")) {
			element = document.getElementById("nav-doc-title");
			element.classList.add("show");
			element.classList.add("active");
		}
		if (document.getElementById("nav-doc-draft")) {
			element = document.getElementById("nav-doc-draft");
			element.classList.remove("show");
			element.classList.remove("active");
		}

		if (document.getElementById("nav-doc-draft")) {
			element = document.getElementById("nav-doc-draft");
			element.classList.remove("show");
			element.classList.remove("active");
		}
		if (document.getElementById("nav-doc-route")) {
			element = document.getElementById("nav-doc-route");
			element.classList.remove("show");
			element.classList.remove("active");
		}
		tab = "nav-doc-title-tab";
	}

	return tab;
};
const principalScreens = { screen1: "hide", screen2: "hide", screen3: "hide" };
const mapDispatchToProps = (dispatch) => ({
	fileUploadActions: (data) => dispatch(fileUploadActions(data)),
	saveInputsAction: (data) => dispatch(saveInputsAction(data)),
	loadRoutes: (data) => dispatch(loadRoutes(data)),
	saveRoutes: (data) => dispatch(saveRoutes(data)),
	getPrincipalHomeScreen: (state, data) =>
		dispatch(getPrincipalHomeScreen(state, data)),
	fileUnSelectionActions: (data) => dispatch(fileUnSelectionActions(data)),
	saveDocBody: (data) => dispatch(saveDocBody(data)),
	fileSelectionActions: (data) => dispatch(fileSelectionActions(data)),
});
const mapStateToProps = (state) => ({ state });
export default connect(mapStateToProps, mapDispatchToProps)(Home);
